import { useEffect } from "react";

type Props = {
  keys: string | string[];
  action: (e: KeyboardEvent) => void;
  alt?: boolean;
  ctrl?: boolean;
  shift?: boolean;
  preventDefault?: boolean;
}[];

const useHotkey = (hotKeys: Props) => {
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    //eslint-disable-next-line
  }, []);

  const handleKeyDown = (e: KeyboardEvent) => {
    const found = hotKeys.find(
      ({ keys }) =>
        (Array.isArray(keys) && keys.includes(e.key)) || keys === e.key
    );

    if (
      found &&
      !!found.alt === e.altKey &&
      !!found.ctrl === e.ctrlKey &&
      !!found.shift === e.shiftKey
    ) {
      if (found.preventDefault ?? true) {
        e.preventDefault();
      }
      found.action(e);
    }
  };
};

export default useHotkey;
